import { createStandardAction } from "typesafe-actions";
import { Chat } from "../../models/Chat";

// eslint-disable-next-line import/prefer-default-export
export const updateChat = createStandardAction("UPDATE_CHAT")<Chat>();
